import React, { useState, useEffect } from 'react';
import api from '../../api';

function QRCode()
{
  const [qrCode, setQrCode] = useState(undefined);

  useEffect(() => {
    const url = window.location.href;
    const gameId = url.split("/").pop();
    setQrCode(response);
    const response = api.getQrCode(gameId).then((response)=>{
      setQrCode(response.data);
    });
  }, []);
  return(
    <div dangerouslySetInnerHTML={{ __html: qrCode}}/>
  );
}

export default QRCode;